import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

const validate = async (values): Promise<FormikErrors<any>> =>  {
    const error: any = {
        criteria: 'failed'
    }
    return error;
}

class CriteriaForm extends React.Component<any, any> {
    
    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                    initialValues={{
                        criteria: JSON.stringify(this.props.config.criteria, null, 2)
                    }}
                    onSubmit={this.props.onSubmit}
                    render={this.form}
                    validate={validate}
                    enableReinitialize={true}
                />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <Form>
        <TextField
            label='Criteria'
            name='criteria'
            margin="normal"
            variant="outlined"
            placeholder={JSON.stringify({
                property: {
                    query: 'city:Toronto',
                    // format: 'JSON',
                    num_records: 50,
                    // download: false,
                },
                business: {
                    query: 'categories:(hotels OR restaurants OR bars)',
                    // format: 'JSON',
                    num_records: 10,
                    // download: true,
                },
                people: {
                    query: '(businessName:Apple OR businessName:Dell) AND city:Austin',
                    // format: 'JSON',
                    num_records: 25,
                    // download: false,
                },
                product: {
                    query: 'categories:shoes',
                    // format: 'JSON',
                    num_records: 100,
                    // download: false,
                },
                tags: [
                    'active listing'
                ]
              }, null, 2)}
            multiline={true}
            fullWidth={true}
            rows="4"
            value={p.values.criteria}
            onChange={p.handleChange}
            onBlur={p.handleBlur}
        />
        <Button style={{width: '100%'}} type="submit" color="primary">Save</Button>
    </Form>
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(CriteriaForm));



// WEBPACK FOOTER //
// ./src/sub-projects/datafiniti/components/criteria-form.tsx